
export default {
  'placeDetails': {
    'layer': 'Couche',
    'lat': 'Lat.',
    'lon': 'Lon.',
    'notAvailable': 'Pas disponible',
    'placeDetails': 'Détails du lieu',
    'placeName': 'Nom',
    'latlngCopied': 'Latitude et longitude copiées',
    'lnglatCopied': 'Longitude et latitude copiées',
    'copyLatlng': 'Copier au format latitude,longitude',
    'copyLnglat': 'Copier au format longitude,latitude',
    'satelliteView': 'vue satellite'
  }
}
